import login from './login';

const loginPlugin = {
  install(Vue) {
    const copyVue = Vue;
    copyVue.prototype.$loginCommercialPlugin = {
      initLogin: login.initLogin,
      checkLogin: login.checkLogin,
      login: login.login,
      logout: login.logout,
      checkRoleInfo: login.checkRoleInfo,
    };
  },
};
export default loginPlugin;
